import type { AutoMapCostFileTemplateAction } from './autoMapCostFileTemplate.action';
import type { ClearCostFileTemplateAction } from './clearCostFileTemplate.action';
import type { ClearCostFileTemplateMapAction } from './clearCostFileTemplateMap.action';
import type { EditCostFileTemplateAction } from './editCostFileTemplate.action';
import type { SetCostFileSampleAction } from './setCostFileSample.action';
import type { SubmitCostFileTemplateAction } from './submitCostFileTemplate.action';
import type { UpdateCostFileTemplateAdPartnerAction } from './updateCostFileTemplateAdPartner.action';
import type { UpdateCostFileTemplateFieldAction } from './updateCostFileTemplateField.action';
import type { UpdateCostFileTemplateStepAction } from './updateCostFileTemplateStep.action';
import type { UpdateCostFileTemplateTitleAction } from './updateCostFileTemplateTitle.action';

export type CostFileTemplateCreatorAction =
  | ClearCostFileTemplateAction
  | ClearCostFileTemplateMapAction
  | UpdateCostFileTemplateStepAction
  | UpdateCostFileTemplateTitleAction
  | UpdateCostFileTemplateAdPartnerAction
  | SetCostFileSampleAction
  | UpdateCostFileTemplateFieldAction
  | EditCostFileTemplateAction
  | SubmitCostFileTemplateAction
  | AutoMapCostFileTemplateAction;

export * from './clearCostFileTemplate.action';
export * from './clearCostFileTemplateMap.action';
export * from './updateCostFileTemplateStep.action';
export * from './updateCostFileTemplateTitle.action';
export * from './updateCostFileTemplateAdPartner.action';
export * from './setCostFileSample.action';
export * from './updateCostFileTemplateField.action';
export * from './editCostFileTemplate.action';
export * from './submitCostFileTemplate.action';
export * from './autoMapCostFileTemplate.action';
